import React from 'react'
import PropTypes from 'prop-types'
import { Fade, Typography, Button, Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import useUnreachableServices from 'hooks/useUnreachableServices'

import useStyles from './styles'

import constants from 'constants/index'

const { ALERT_TITLE, ALERT_ACTION_LABEL, alertMessage, REACHABILITY } =
  constants.externalServices

// Avisa que a rede do usuário está bloqueando um ou mais serviços, nomeando os
// hosts que o TI precisa liberar. Não renderiza nada enquanto tudo estiver
// alcançável nem enquanto a verificação corre.
const ServiceUnreachableAlert = ({ services = [], onRetry }) => {
  const { unreachableHosts, hasUnreachable, recheckAll } =
    useUnreachableServices(services)

  const classes = useStyles()

  const handleRetry = async () => {
    const results = await recheckAll()
    const allReachable = results.every(
      (reachability) => reachability === REACHABILITY.REACHABLE,
    )

    if (allReachable && onRetry) onRetry()
  }

  if (!hasUnreachable) return null

  const hosts = unreachableHosts.join(' e ')

  return (
    <Fade in>
      <Box className={classes.alertContainer}>
        <Alert
          variant="outlined"
          severity="error"
          action={
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={handleRetry}
            >
              {ALERT_ACTION_LABEL}
            </Button>
          }
        >
          <Typography>
            <strong>{ALERT_TITLE}</strong> {alertMessage(hosts)}
          </Typography>
        </Alert>
      </Box>
    </Fade>
  )
}

ServiceUnreachableAlert.propTypes = {
  services: PropTypes.arrayOf(PropTypes.string),
  onRetry: PropTypes.func,
}

export default ServiceUnreachableAlert
